import React, { Component } from 'react';
import Heading from '~/UI/Heading/Heading';
import compactInputStyles from '~/UI/Input/compact.less';
import Input from '~/UI/Input/Input';
import Popover from '~/UI/Popover';

interface Props {
	link: string | null;
	referenceRect: ClientRect | null;
	onClose(event: MouseEvent): void;
}

export default class ShareLinkPopover extends Component<Props> {
	static defaultProps = {
		link: null,
		referenceRect: null,
	};

	inputElement: Input | null = null;

	componentDidMount() {
		if (this.inputElement !== null) {
			this.inputElement.focus();
		}
	}

	render() {
		const { link, referenceRect, onClose } = this.props;

		return referenceRect ? (
			<Popover referenceRect={referenceRect} width={320} onClose={onClose}>
				<Heading level={5}>Link</Heading>
				<Input
					readOnly
					name='share-link'
					ref={(ref) => (this.inputElement = ref)}
					styles={compactInputStyles}
					type='text'
					value={link === null ? window.location.href : link}
					onClick={this.selectAllText}
					onFocus={this.selectAllText}
				/>
			</Popover>
		) : null;
	}

	selectAllText = () => {
		if (this.inputElement) {
			this.inputElement.selectAllText();
		}
	};
}
